module.exports = __webpack_public_path__ + "img/Group 27153.589c1f19.svg";